import { createSlice } from "@reduxjs/toolkit";
import { save_tokens_constant, asyncStatus } from "../../utils/asyncStatus";
import { check_auth, login_service_auth } from "../../services/authentication";
import {
  success_toast_message,
  error_toast_message,
} from "../../utils/toast_message";
import { getAllOrdersAsync, getOderByIdAsync, updateOrderStatusAsync } from "../../services/OrderManagementService";


const initialState = {
  // GET ALL STORES >>>>>>>>>>>>>
  get_all_orders_status: asyncStatus.IDLE,
  get_all_orders_data: null,
  get_all_orders_error: null,

  // GET STORE BY ID >>>>>>>>>>>>>
  get_order_by_id_status: asyncStatus.IDLE,
  get_order_by_id_data: null,
  get_order_by_id_error: null,

  // EDIT STORE >>>>>>>>>>>>>
  update_order_status_status: asyncStatus.IDLE,
  update_order_status_data: null,
  update_order_status_error: null,
};

const StoreManagementSlice = createSlice({
  name: "store_management",
  initialState,
  reducers: {
    setIdleStatus(state) {
      state.login_status = asyncStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    // GET ALL ORDERS >>>>>>>>>>>>>
    builder.addCase(getAllOrdersAsync.pending, (state, action) => {
      state.get_all_orders_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllOrdersAsync.fulfilled, (state, { payload }) => {
      state.get_all_orders_status = asyncStatus.SUCCEEDED;
      state.get_all_orders_data = payload.data;
    });

    builder.addCase(getAllOrdersAsync.rejected, (state, action) => {
      state.get_all_orders_status = asyncStatus.ERROR;
      state.get_all_orders_error = action.error;
      error_toast_message(action.error.message);
    });

    // GET ORDER BY ID >>>>>>>>>>>>>
    builder.addCase(getOderByIdAsync.pending, (state, action) => {
      state.get_order_by_id_status = asyncStatus.LOADING;
    });

    builder.addCase(getOderByIdAsync.fulfilled, (state, { payload }) => {
      state.get_order_by_id_status = asyncStatus.SUCCEEDED;
      state.get_order_by_id_data = payload?.data;
    });

    builder.addCase(getOderByIdAsync.rejected, (state, action) => {
      state.get_order_by_id_status = asyncStatus.ERROR;
      state.get_order_by_id_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT ORDER >>>>>>>>>>>>>
    builder.addCase(updateOrderStatusAsync.pending, (state, action) => {
      state.update_order_status_status = asyncStatus.LOADING;
    });

    builder.addCase(updateOrderStatusAsync.fulfilled, (state, { payload }) => {
      state.update_order_status_status = asyncStatus.SUCCEEDED;
      state.update_order_status_data = payload.data;
      success_toast_message("Store status updated successfully");
    });

    builder.addCase(updateOrderStatusAsync.rejected, (state, action) => {
      state.update_order_status_status = asyncStatus.ERROR;
      state.update_order_status_error = action.error;
      error_toast_message(action.error.message);
    });
  },
});

export const { setIdleStatus } = StoreManagementSlice.actions;

export default StoreManagementSlice.reducer;
